export const heroSlides = [
  {
    image: '/assets/hero-darila-wide.jpg',
    mobileImage: '/assets/hero-darila.jpg',
    bright: true,
    title: {
      sl: 'POSLOVNA DARILA\nZ VAŠIM LOGOTIPOM',
      en: 'CORPORATE GIFTS\nWITH YOUR LOGO',
      it: 'REGALI AZIENDALI\nCON IL VOSTRO LOGO'
    },
    description: {
      sl: 'Gravirane steklenice, termo skodelice, pisala in tekstil. Tisk in gravura že od 1 kosa. Hitra izdelava, osebno svetovanje.',
      en: 'Engraved bottles, thermo mugs, pens and textiles. Printing and engraving from 1 piece. Fast turnaround, personal advice.',
      it: 'Borracce incise, tazze termiche, penne e tessuti. Stampa e incisione già da 1 pezzo. Realizzazione rapida, consulenza personale.'
    },
    badges: [
      { sl: 'Obdarovanje 2026', en: 'Gifting 2026', it: 'Regali 2026' },
      { sl: 'Od 1 kosa', en: 'From 1 piece', it: 'Da 1 pezzo' },
      { sl: 'Izdelava v 2–3 dneh', en: 'Ready in 2–3 days', it: 'Pronti in 2–3 giorni' }
    ],
    buttonText: { sl: 'Zahtevaj ponudbo', en: 'Request a quote', it: 'Richiedi un preventivo' },
    buttonLink: '/contact'
  },
  {
    image: '/assets/hero-merch-bg.jpg',
    feature: '/assets/hero-merch.jpg',
    title: {
      sl: 'TVOJA IDEJA. NATISNJENA PO TVOJE.',
      en: 'YOUR IDEA. PRINTED YOUR WAY.',
      it: 'LA TUA IDEA. STAMPATA A MODO TUO.'
    },
    description: {
      sl: 'Personaliziran tisk na majice, kape, nakupovalne torbe in drug tekstil – DTF tisk vrhunske kakovosti, tudi za en sam kos. Vaš dizajn, naša izvedba.',
      en: 'Personalised printing on t-shirts, caps, tote bags and other textiles – premium DTF quality, even for a single piece. Your design, our craft.',
      it: 'Stampa personalizzata su magliette, cappellini, borse shopper e altri tessuti – qualità DTF premium, anche per un solo pezzo. Il tuo design, la nostra esecuzione.'
    },
    badges: [
      { sl: 'Tisk po naročilu', en: 'Printed on demand', it: 'Stampa su richiesta' },
      { sl: 'Brez minimalne količine', en: 'No minimum orders', it: 'Nessun minimo d\'ordine' },
      { sl: 'Oblikuj. Natisni. Nosi.', en: 'Design it. Print it. Wear it.', it: 'Crea. Stampa. Indossa.' }
    ],
    buttonText: { sl: 'Naroči svoj tisk', en: 'Order your print', it: 'Ordina la tua stampa' },
    buttonLink: '/contact',
    secondaryText: { sl: 'Poglej primere', en: 'See examples', it: 'Vedi esempi' },
    secondaryLink: '/services/dtf-printing'
  },
  {
    image: "https://images.unsplash.com/photo-1503694978374-8a2fa686963a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxwcmludGluZyUyMHByZXNzfGVufDB8fHx8MTc3MTU5NDgyN3ww&ixlib=rb-4.1.0&q=85",
    title: {
      sl: 'TISKAMO ZGODBE PODJETIJ IN TRENUTKE POSAMEZNIKOV',
      en: 'WE PRINT BUSINESS STORIES AND INDIVIDUAL MOMENTS',
      it: 'STAMPIAMO STORIE AZIENDALI E MOMENTI INDIVIDUALI'
    },
    description: {
      sl: 'Oživite svoje ideje s hitrim, kakovostnim tiskom in rešitvami po meri. Od vizitk do velikoformatnega tiska.',
      en: 'Bring your ideas to life with fast, quality printing and custom solutions. From business cards to large format printing.',
      it: 'Date vita alle vostre idee con stampa rapida, di qualità e soluzioni personalizzate. Dai biglietti da visita alla stampa grande formato.'
    },
    buttonText: { sl: 'Pridobite svojo ponudbo', en: 'Get Your Quote', it: 'Ottieni il Tuo Preventivo' },
    buttonLink: '/contact'
  },
  {
    image: "/assets/dtf-banner.jpg",
    title: {
      sl: 'PRI NAS LAHKO NAROČITE DTF PRESLIKAČE ZA PROFESIONALNE REZULTATE',
      en: 'ORDER DTF TRANSFERS FOR PROFESSIONAL RESULTS',
      it: 'ORDINA TRASFERIMENTI DTF PER RISULTATI PROFESSIONALI'
    },
    description: {
      sl: 'Enostaven prenos s toplotno prešo, žive barve ter odlična in dolgotrajna obstojnost.',
      en: 'Easy transfer with heat press, vibrant colors and excellent long-lasting durability.',
      it: 'Trasferimento facile con pressa a caldo, colori vivaci ed eccellente durata nel tempo.'
    },
    buttonText: { sl: 'Naročite DTF preslikače', en: 'Order DTF Transfers', it: 'Ordina Trasferimenti DTF' },
    buttonLink: '/contact'
  }
];
